export default __webpack_public_path__ + "static/media/covid.b41d4ce3.png";